import React from 'react';
import { FormLayout } from '../form-layout/form-layout';
import { Responsive } from '../responsive/responsive';
import './form-row-layout.scss';

export type FormRowLayoutProps = {
  children: (() => React.ReactFragment)[];
};

export function FormRowLayout(props: FormRowLayoutProps) {
  return (
    <div className="FormRowLayout">
      <Responsive>
        {(isMobile) =>
          isMobile ? (
            <FormLayout>
              {props.children.map((rowComponent, index) => (
                <div key={index}>{rowComponent()}</div>
              ))}
            </FormLayout>
          ) : (
            <FormLayout>
              {[
                <div className="combo-field columns" key="bothInputs">
                  {props.children.map((rowComponent, index) => (
                    <div className="column" key={index}>
                      {rowComponent()}
                    </div>
                  ))}
                </div>,
              ]}
            </FormLayout>
          )
        }
      </Responsive>
    </div>
  );
}
